import React from "react";
import { useNavigate } from "react-router-dom";
import { IconButton, Typography } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import privacyPolicyConfig from "./PrivacyPolicy.config";
import "./PrivacyPolicy.style.css";

const PrivacyPolicy = () => {
  const navigate = useNavigate();
  const { pageTitle, sections } = privacyPolicyConfig;

  return (
    <div className="privacy-policy-page">
      <header className="privacy-header">
        {/* <IconButton
          type="button"
          className="privacy-header-back"
          onClick={() => navigate("-1")}
          aria-label="Back to home"
          size="small"
        >
          <ArrowBack fontSize="small" />
        </IconButton> */}
        <div className="privacy-header-inner">
          <Typography
            component="h1"
            variant="h4"
            className="privacy-page-title"
          >
            {pageTitle}
          </Typography>
        </div>
      </header>

      <main className="privacy-body">
        {sections.map((section) => (
          <article
            key={section.id}
            className="privacy-section"
            aria-labelledby={`privacy-section-${section.id}`}
          >
            <Typography
              component="h2"
              id={`privacy-section-${section.id}`}
              variant="subtitle1"
              className="privacy-section-title"
            >
              {section.title}
            </Typography>

            {(section.paragraphs || []).map((content, index) => (
              <Typography
                key={`${section.id}-p-${index}`}
                component="p"
                variant="body1"
                className="privacy-paragraph"
              >
                {content}
              </Typography>
            ))}

            {(section.subsections || []).map((sub, subIndex) => (
              <section
                key={`${section.id}-sub-${subIndex}`}
                className="privacy-subsection"
                aria-labelledby={`privacy-sub-${section.id}-${subIndex}`}
              >
                <Typography
                  component="h3"
                  id={`privacy-sub-${section.id}-${subIndex}`}
                  variant="subtitle2"
                  className="privacy-subtitle"
                >
                  {sub.subtitle}
                </Typography>
                {(sub.paragraphs || []).map((content, pIndex) => (
                  <Typography
                    key={`${section.id}-sub-${subIndex}-p-${pIndex}`}
                    component="p"
                    variant="body1"
                    className="privacy-paragraph"
                  >
                    {content}
                  </Typography>
                ))}
              </section>
            ))}
          </article>
        ))}
      </main>
    </div>
  );
};

export default PrivacyPolicy;